// @flow
import React from 'react';
// Styles
import './BottomRow.css';
// Components
import { DepartmentsNavList } from '../../departments';

const BottomRow = () => {
  return (
    <div className="bottomrow-container">
      <DepartmentsNavList />
    </div>
  );
};

export default BottomRow;
